import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BoxOfficesService {

  boxOffice = 
  [
  {
    title:"Straight Outta Compton" , 
    price:"26.760" , 
    link:'https://www.imdb.com/title/tt1398426/?ref_=fn_al_tt_1'
  } , 
 
  
  {
    title:"Sinister 2" , 
    price:"10.633" , 
    link:'https://www.imdb.com/title/tt2752772/?ref_=fn_al_tt_1'
  } , 
  {
    title:"Hitman: Agent 47" , 
    price:"8.200", 
    link:'https://www.imdb.com/title/tt2679042/?ref_=fn_al_tt_1'
  },
  {
    title:"The Man from U.N.C.L.E. " , 
    price:"7.420", 
    link:'https://www.imdb.com/title/tt1638355/?ref_=fn_al_tt_1'
  },
  {
    title:"American Ultra" , 
    price:"5.500" , 
    link:'https://www.imdb.com/title/tt3316948/?ref_=fn_al_tt_1'
  },
  {
    title:"The Gift" , 
    price:"4.300" , 
    link:'https://www.imdb.com/title/tt4178092/?ref_=fn_al_tt_1'
  },
  {
    title:"Ant-Man" , 
    price:"4.088" , 
    link:'https://www.imdb.com/title/tt0478970/?ref_=fn_al_tt_1'
  }



  ]

  constructor() { }
}
